// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65fbb074","455":"1b0a6a6b","503":"0d1b2e4f","638":"5a2218ab","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};